export default __webpack_public_path__ + "locales/de/PeopleTranslations.json?hash=35d7d5084ae5ca966c0e8ee1afae7305";